import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormUp } from 'grommet-icons';
import { StyledReactTooltip } from './StyledButtons';

const StyledScrollButton = styled.button`
  position: fixed;
  right: 1rem;
  bottom: 2rem;
  z-index: 1000;
  background: ${({ $bg, $overrideHover }) => ($overrideHover ? 'linear-gradient(#0000, rgb(0 0 0/40%)) top/100% 800%' : $bg)};
  background-color: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color || 'var(--button-primary-text)'};
  border: none;
  border-radius: 50%;
  width: 3.2rem;
  height: 3.2rem;
  box-shadow: var(--elevation-active);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transition: all 0.25s ease-in-out;

  &:hover {
    ${({ $overrideHover }) => $overrideHover && ('background-position: bottom;')}
    background-color: ${({ $bg, $hoverBg, $overrideHover }) => ($overrideHover ? $bg : $hoverBg)};
  }
`;

const ScrollToTopButton = ({
  threshold = 300,
  iconSize = '2.5rem',
  bg = 'var(--page-highlight)',
  hoverBg = 'var(--page-alt-highlight)',
  color = 'var(--button-primary-text)',
  tooltipColor = 'var(--page-highlight)',
  tooltipPosition = 'left',
  tooltipMessage = 'Back to top',
  overrideHover = false,
  ...rest
}) => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > threshold);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <StyledScrollButton
      type="button"
      aria-label="Back to top"
      data-tip={tooltipMessage}
      data-for="scroll-to-top-tooltip"
      onClick={handleClick}
      $bg={bg}
      $hoverBg={hoverBg}
      $color={color}
      $visible={visible}
      $overrideHover={overrideHover}
      {...rest}
    >
      <FormUp color={color} size={iconSize} />
      <StyledReactTooltip
        effect="solid"
        id="scroll-to-top-tooltip"
        className="copyTooltip"
        place={tooltipPosition}
        arrowColor={tooltipColor}
        bgColor={tooltipColor}
        backgroundColor={tooltipColor}
      />
    </StyledScrollButton>
  );
};

ScrollToTopButton.propTypes = {
  threshold: PropTypes.number,
  iconSize: PropTypes.string,
  bg: PropTypes.string,
  hoverBg: PropTypes.string,
  color: PropTypes.string,
  tooltipColor: PropTypes.string,
  tooltipPosition: PropTypes.string,
  tooltipMessage: PropTypes.string,
  overrideHover: PropTypes.bool,
};

export default ScrollToTopButton;
